function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 7,
  cy: 7,
  r: 5,
  fill: "black",
  stroke: "black",
  strokeWidth: 1.2
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 5.5,
  cy: 5.9,
  rx: 0.5,
  ry: 0.9,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.5,
  cy: 5.9,
  rx: 0.5,
  ry: 0.9,
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9 8C9 8.47739 8.78929 8.93523 8.41421 9.27279C8.03914 9.61036 7.53043 9.8 7 9.8C6.46957 9.8 5.96086 9.61036 5.58579 9.27279C5.21071 8.93523 5 8.47739 5 8H9Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1.2,
  rx: 0.6,
  fill: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1.2,
  rx: 0.6,
  transform: "matrix(1 0 0 -1 0 14)",
  fill: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1.2,
  rx: 0.6,
  transform: "matrix(-1 0 0 1 14 0)",
  fill: "black"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 14,
  y: 14,
  width: 3,
  height: 1.2,
  rx: 0.6,
  transform: "rotate(-180 14 14)",
  fill: "black"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  x: 1.19995,
  width: 3,
  height: 1.2,
  rx: 0.6,
  transform: "rotate(90 1.19995 0)",
  fill: "black"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1.2,
  rx: 0.6,
  transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 1.19995 14)",
  fill: "black"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  width: 3,
  height: 1.2,
  rx: 0.6,
  transform: "matrix(4.37114e-08 1 1 -4.37114e-08 12.8 0)",
  fill: "black"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  x: 12.8,
  y: 14,
  width: 3,
  height: 1.2,
  rx: 0.6,
  transform: "rotate(-90 12.8 14)",
  fill: "black"
});

var SvgFaceRec = function SvgFaceRec(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaceRec, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face_rec.d11c4b34.svg";
export { ForwardRef as ReactComponent };